import { useTranslation } from "react-i18next";

/**
 * Composant affichant l'état vide du panneau de notifications
 * Style Material Design avec illustration
 */
const U2000NotificationEmpty = () => {
  const { t } = useTranslation("u2000");

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      {/* Illustration */}
      <div className="mb-4 w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center">
        <svg className="w-12 h-12 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
      </div>

      {/* Message */}
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{t("lblNoNotifications")}</h3>
      <p className="text-sm text-gray-500 text-center max-w-xs">{t("lblNoNotificationsDescription")}</p>
    </div>
  );
};

export default U2000NotificationEmpty;
